import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom"; // ✅ import this
import RGB from "../assets/images/LGB.webp";
import { FaEnvelope, FaLock } from "react-icons/fa";

const initialState = {
  email: "",
  password: "",
};

const Login = () => {
  const [formData, setFormData] = useState(initialState);
  const navigate = useNavigate(); // ✅ initialize navigate

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const clearState = () => setFormData({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/login`,
        formData
      );

      const { token, user } = response.data;

      // ✅ Save token and user info in localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      Swal.fire({
        title: "Success!",
        text: "Login successful!",
        icon: "success",
        confirmButtonText: "Continue",
      }).then(() => {
        clearState();

        // ✅ Navigate based on isAdmin
        if (user.isAdmin === 1 || user.isAdmin === true) {
          navigate("/dashboard");
        } else {
          navigate("/");
        }
      });
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text:
          error.response?.data?.message || "Login failed. Please try again.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
    }
  };

  return (
    <div
      className="container"
      style={{
        alignContent: "center",
        padding: "0 50px",
        backgroundColor: "aliceblue",
        minHeight: "80vh",
        margin: "100px auto",
      }}
    >
      <div
        className="row bg-white shadow-lg rounded-4 overflow-hidden mt-5"
        style={{ width: "100%" }}
      >
        {/* Left Side - Image */}
        <div className="col-md-6 d-none d-md-flex align-items-center justify-content-center bg-light text-center">
          <img
            src={RGB}
            alt="Login Visual"
            className="img-fluid"
            style={{ maxHeight: "420px", objectFit: "contain" }}
          />
        </div>

        {/* Right Side - Form */}
        <div className="col-md-6" style={{ justifyContent: "center" }}>
          <h2 className="text-center text-primary fw-bold mt-5">
            Login Account
          </h2>
          <div
            className="d-flex justify-content-center align-items-center pt-3 pb-3 bg-light"
            style={{ width: "100%", justifyItems: "center" }}
          >
            <div className="bg-white p-4 rounded shadow formBox">
              <form onSubmit={handleSubmit}>
                {[
                  {
                    icon: <FaEnvelope />,
                    name: "email",
                    placeholder: "Email",
                    type: "email",
                  },
                  {
                    icon: <FaLock />,
                    name: "password",
                    placeholder: "Password",
                    type: "password",
                  },
                ].map(({ icon, name, placeholder, type }) => (
                  <div
                    key={name}
                    style={{
                      display: "flex",
                      fontSize: 20,
                      alignItems: "center",
                      marginBottom: 20,
                    }}
                  >
                    <span
                      className="input-group-text bg-primary text-white"
                      style={{ padding: 4, marginRight: 8 }}
                    >
                      {icon}
                    </span>
                    <input
                      type={type}
                      name={name}
                      className="form-control px-3 py-2"
                      placeholder={placeholder}
                      value={formData[name]}
                      onChange={handleChange}
                      required={[
                        "name",
                        "email",
                        "password",
                        "confirmPassword",
                      ].includes(name)}
                    />
                  </div>
                ))}

                <div style={{ textAlign: "center" }}>
                  <button
                    type="submit"
                    className="btn btn-primary w-100 fw-bold py-2 mt-2"
                    style={{ width: "80%", fontWeight: "bold" }}
                  >
                    Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
